import React from 'react';

function Box (props) {
    return (  
        <div className='s-box'>
            <div className='s-b-img'>
                <img src={props.image} alt={props.alt}></img>
            </div>
            <div className='s-b-text'>
            <h1 className='box-header'>Domicilliary Care </h1>
                <p>JCR healthcare specialises in providing Domicilliary care using highly experienced, qualified and vetted healthcare professionals.</p>
            </div>

        </div>
    );
}
 
export default Box;